import { BOOK_ENTERPRISE_DEMO } from "../../constant";
import getSTarted from "../../assets/images/svgs/get_started.svg";

export const ProductDemoFooter = () => (
  <div
    className="product-demo fixed bottom-0 left-0 w-full z-50"
    style={{
      backgroundImage: `url(${getSTarted})`,
    }}
  >
    <div className="heading-content">
      <div className="heading">See Altimate AI Teammates in Action!</div>
      <div className="content">
        <p>
          Share your email address to view a recorded demo.
        </p>
      </div>
    </div>
    <a href={BOOK_ENTERPRISE_DEMO} target="_blank" rel="noreferrer">
      <button>
        See Product Demo
      </button>
    </a>
  </div>
);
